import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../components/mybids/mybids.css";
import { useNavigate } from "react-router-dom";
import placeimg from "../../myimgs/Group 193.png";


const Purchagerequest = () => {
  const [auctions, setAuctions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const handleViewDetails = (id, propeId) => {
    // Open the route in a new tab with query params
    const url = `/propertyDetail?id=${id}&propeId=${propeId}`;
    window.open(url, "_blank");
  };
  useEffect(() => {
    const fetchBids = async () => {
      const userId = localStorage.getItem("userId");
      if (!userId) return;

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/property-request/by-user?userId=${userId}`
        );

        setAuctions(response.data.data || []);
      } catch (error) {
        console.error("Error fetching bids:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBids();
  }, []);
  if (loading)
    return (
      <div className="loader-wrapper">
        <div className="loader"></div>
      </div>
    );

  // timersss  ...
   function Countdown({ start, end }) {
    const [timeLeft, setTimeLeft] = useState("");
  
    // ✅ Function to format date as "DD-MM-YYYY, HH:MM"
    const formatDateTime = (dateString) => {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${day}-${month}-${year}, ${hours}:${minutes}`;
    };
  
    const getRemainingTime = (startTime, endTime) => {
      const now = new Date();
      const startDate = new Date(startTime);
      const endDate = new Date(endTime);
  
      // ✅ Before start → show "Starts In:"
      if (now < startDate) {
        return (
          <>
            <strong>Starts In:</strong>
            <br />
            {formatDateTime(startDate)}
          </>
        );
      }
  
      const diff = endDate - now;
      if (diff <= 0) return "Ended";
  
      // ✅ After start → show "Ends In:"
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);
  
      return (
        <>
          <strong>Ends In:</strong>
          <br />
          {`${days}D : ${hours}H : ${minutes}M : ${seconds}s`}
        </>
      );
    };
  
    useEffect(() => {
      const interval = setInterval(() => {
        setTimeLeft(getRemainingTime(start, end));
      }, 1000);
  
      return () => clearInterval(interval);
    }, [start, end]);
  
    return <h3>{timeLeft}</h3>;
  }

  // timersss  ...
  return (
    <div className="auction-container">
      <h2 className="auction-title">My Purchase Request</h2>
      {!auctions.length && !loading && (
        <p style={{ textAlign: "center", marginTop: "10px" }}>No data found</p>
      )}
      <div className="auction-list">
        {auctions.map((auction) => (
          <div key={auction.id} className="auction-card kjui">
            {/* Image */}
            <img
              src={
                auction.propertyImages?.[0]?.imageUrl
                  ? auction.propertyImages[0].imageUrl
                  : placeimg
              }
              alt="Property"
            />

            <div className="auction-info">
              <div className="auction-details">
                <p className="listed-by">
                  Listed by <span>{auction.user?.name}</span>
                </p>

                {/* Address */}
                <h3 className="address">{auction.unparsedAddress}</h3>

                <div className="property-specs">
                  {auction.bedroomsTotal && (
                    <span className="spec">🛏{auction.bedroomsTotal}bed</span>
                  )}

                  {auction.bathroomsTotalInteger && (
                    <span className="spec">
                      🛁{auction.bathroomsTotalInteger}bath
                    </span>
                  )}

                  {auction.lotSizeArea && (
                    <span className="spec">📐{auction.lotSizeArea}ft²</span>
                  )}
                </div>

                {/* Countdown Timer */}
                <div className="timebtn lko">
                  <Countdown
                    start={auction.biddingDetails?.bidingStartDateTime}
                    end={auction.biddingDetails?.bidingEndDateTime}
                  />
                </div>
              </div>

              <div className="price-section">
                {/* <p className="price-label">Current Valuation</p> */}

                <h4 className="price">
                  $
                  {(
                    auction.biddingDetails?.currenntAuctionAmount ||
                    auction.biddingDetails?.offerStartingPrice
                  )?.toLocaleString()}
                </h4>

                <button
                  className="view-btn"
                  onClick={() => {
                    handleViewDetails(auction.id, auction.propeId);
                  }}
                >
                  View Details
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Purchagerequest;
